import { Component, inject, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LicenseStateService } from '../../core/services/license-state-service/license-state-service';
import { featureTierLabels } from '../../school-license/models/license-feature.model';
import { ReleaseNote, ReleaseNoteKind } from '../release-notes';

const KIND_LABELS: Record<ReleaseNoteKind, string> = {
  new: 'Nové',
  improvement: 'Vylepšení',
  fix: 'Oprava',
};

const KIND_CLASSES: Record<ReleaseNoteKind, string> = {
  new: 'bg-primary-container text-on-primary-container',
  improvement: 'bg-secondary-container text-on-secondary-container',
  fix: 'bg-tertiary-container text-on-tertiary-container',
};

/** Whether a click navigates the current tab — a modified click opens the link elsewhere. */
export function navigatesInPlace(event: MouseEvent): boolean {
  return event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;
}

/** Releases newest first, each a dated list of changes — shared by the dialog and the page. */
@Component({
  selector: 'app-release-notes-list',
  imports: [DatePipe, RouterLink],
  templateUrl: './release-notes-list.html',
})
export class ReleaseNotesList {
  protected readonly licenseState = inject(LicenseStateService);

  readonly notes = input.required<readonly ReleaseNote[]>();
  /** Lets the dialog close itself once the user follows a link out of it. */
  readonly linkFollowed = output<void>();

  protected readonly kindLabels = KIND_LABELS;
  protected readonly kindClasses = KIND_CLASSES;
  protected readonly tierLabels = featureTierLabels;

  protected onLinkClick(event: MouseEvent): void {
    if (navigatesInPlace(event)) this.linkFollowed.emit();
  }
}
